module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABUElEQVRYR+3VPU7DMBjG8X8SICCoxMDMDTgBEweAoTMVpRErh2FFLUVlBgkOwMYFuAEzA1L5ClUcFCQ+hETsvG8sMThr/Ng/PXacqCzLhH/8RAGo3J3QoLJAQoOhQW0D2nw4g6FBbQPavPUMJiMOjOEQWNMu9it/H8ccFQOO6+atBaZjtt9mXLQM+54uolyYo5v3ufprjVpgMmRoDHvegEAcc1pkZFLgiTH0PAMnRca+CLgyZuNpxg2w5An5vDzP5mOfWxGwCi2O2MoLLj0gX9KEndcB1+KP5DPoAemEq9a3XjMekM64RsCWtrsRrjFQiWyMEwGFSBFODGyIFONUQEekCqcGWpBqXCvAL6ThnJLOx7UUMU1jurZL2OXv5HwP2iZbnbA+zdmtxnVSzh563NkyLu9bA7osJhkTgJLWfmZCg6FBbQPafDiDoUFtA9r8O3WX5ilkduCqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_xiala.png
// module id = 1AmB
// module chunks = 3